import { useAppSelector } from 'hooks/use-app-selector'
import { useAuthUser } from 'next-firebase-auth'
import { useEffect, useRef } from 'react'
import { selectAiSubscriptionLoaded, selectIsAiSubscriptionActive } from 'store/slices/subscription/subscription'
import { setSubscriptionStatusToCookie } from 'utils/set-subscription-status-to-cookie'

/**
 * Custom hook to manage subscription cookie for server-side consumption
 * This hook sets the cookie when subscription info is loaded
 * Sets positive cookie when user is logged in and is a subscriber
 * Sets negative cookie when user is not logged in or not a subscriber
 */
export const useSubscriptionCookie = (): void => {
  const cookieHasBeenSet = useRef(false)
  const isSubscriber = useAppSelector(selectIsAiSubscriptionActive)
  const subscriptionInfoLoaded = useAppSelector(selectAiSubscriptionLoaded)
  const authUser = useAuthUser()
  const authLoaded = authUser.clientInitialized
  const isLoggedIn = !!authUser.id

  useEffect(() => {
    if (authLoaded && subscriptionInfoLoaded) {
      if (!isLoggedIn || !isSubscriber) {
        // Set negative cookie if user is not logged in or not a subscriber
        setSubscriptionStatusToCookie(false)
      } else {
        // Set positive cookie if user is logged in and is a subscriber
        setSubscriptionStatusToCookie(true)
      }
      cookieHasBeenSet.current = true
    }
  }, [subscriptionInfoLoaded, isSubscriber, authLoaded, isLoggedIn])
}
